import { useTranslation } from 'react-i18next'

import { BuildingSelect } from '../../../Building'
import { getMockCalendarBuildings } from '../../Calendar.mock'
import { CalendarRailBlock } from '../CalendarRailBlock'

import { QA_NAME_CALENDAR_RAIL_BUILDING } from './CalendarRailBuilding.constants'
import {
  getCalendarRailBuildingOption,
  toCalendarRailBuilding,
} from './CalendarRailBuilding.utils'

// TODO: search the real buildings and building groups once the calendar feed
// filters by them.
function CalendarRailBuilding({ building, onChange }) {
  const { t } = useTranslation()

  function handleClearBuilding() {
    onChange({ building: null })
  }

  function handleSelectBuilding(option) {
    onChange({ building: toCalendarRailBuilding(option) })
  }

  return (
    <CalendarRailBlock title={t('Calendar.RailObjectKey')}>
      <BuildingSelect
        controlProps={{
          contentProps: {
            inputProps: { placeholder: t('Calendar.RailObjectAllKey') },
          },
        }}
        getData={getMockCalendarBuildings}
        qaName={QA_NAME_CALENDAR_RAIL_BUILDING}
        value={getCalendarRailBuildingOption(building)}
        onClear={handleClearBuilding}
        onSelectItem={handleSelectBuilding}
      />
    </CalendarRailBlock>
  )
}

export default CalendarRailBuilding
